<template>
  <div class="custom-container" v-loading.fullscreen.lock="loyaltyItem.isLoading">
    <el-row>
      <el-row type="flex" align="center" class="my-4" justify="space-between">
        <el-col :span="5">
          <div class="category-title">Edit Loyalty Item</div>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end">
            <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
            <el-button size="small" type="primary" @click="save">Simpan</el-button>
          </el-row>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form label-position="left" ref="loyaltyItem" label-width="120px" :model="loyaltyItem.data">
          <Form :bodyLoyaltyItem="loyaltyItem.data" from="edit"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    Form
  },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      loyaltyItem: state => state.loyaltyItem.loyaltyItem
    })
  },
  methods: {
    ...mapActions({
      getLoyaltyItem: "loyaltyItem/GetLoyaltyItem",
      updateLoyaltyItem: "loyaltyItem/UpdateLoyaltyItem"
    }),
    save() {
      this.$refs.loyaltyItem.validate(valid => {
        if (valid) {
          const bodyLoyaltyItem = {
            filter: {
              _id: this.loyaltyItem.data.id
            },
            data: {
              name: this.loyaltyItem.data.name,
              price: this.loyaltyItem.data.price,
              categoryKey: this.loyaltyItem.data.categoryKey,
              imageURL: this.loyaltyItem.data.imageURL,
              description: this.loyaltyItem.data.description
            }
          }
          this.updateLoyaltyItem(bodyLoyaltyItem);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getLoyaltyItem(this.id);
  }
};
</script>

<style>
</style>
